import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'

interface Partner {
  id: string
  email: string
  first_name?: string
  last_name?: string
  created_at: string
  total_referrals: number
  active_referrals: number
  link_referrals: number
  instagram_referrals: number
  referrals_with_active_applications: number
}

interface PartnersResponse {
  count: number
  next?: string | null
  previous?: string | null
  results: Partner[]
}

interface UsePartnersParams {
  search?: string
  limit?: number
  offset?: number
}

export const partnersQueryKey = ['partners']

export function usePartners(params: UsePartnersParams = {}) {
  async function getPartners(): Promise<PartnersResponse> {
    const searchParams = new URLSearchParams()
    
    if (params.search) searchParams.append('search', params.search)
    if (params.limit) searchParams.append('limit', params.limit.toString())
    if (params.offset) searchParams.append('offset', params.offset.toString())

    const query = searchParams.toString() ? `?${searchParams.toString()}` : ''
    
    const response = await apiClient.get<PartnersResponse>(
      BACK_OFFICE_PREFIX + `partners${query}`
    )
    return response.data
  }

  return useQuery({
    queryFn: getPartners,
    queryKey: [...partnersQueryKey, params]
  })
}